import { TFunction } from 'i18next';

export const mapLanguageDropdownLabel = (
    t: TFunction,
    isMultiLanguageShopEnabled: boolean,
    selectedLanguage: { readonly key: string; readonly value: string }
) => {
    return isMultiLanguageShopEnabled
        ? t('menu.shop.languages.learn', { selectedLanguage: selectedLanguage.value })
        : selectedLanguage.value;
};
